import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase);

export default {
	init() {
		console.log('overview');

		var isLoaded = false;

		jQuery(document).ready(function ($) {
			var $body = $('body'),
				$overviewItems = $('.overview_item'),
				$header = $('.main_header'),
				$main = $('main');

			window.addEventListener('load', function () {
				isLoaded = true;
				showElements();
			});

			setTimeout(function () {
				if (!isLoaded) {
					showElements();
				}
			}, 1000);

			$overviewItems.hover(
				function () {
					var group = $(this).attr('data-group');
					$('[data-group="' + group + '"]').addClass('is-hover');
				},
				function () {
					$overviewItems.removeClass('is-hover');
				}
			);

			let thumbsTw = gsap.to($overviewItems, {
				opacity: 1,
				y: 0,
				duration: 1,
				stagger: 0.02,
				ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
				paused: true,
			});

			function showElements() {
				$body.removeClass('intro--off');
				gsap.to([$header, $main], {
					y: '0',
					delay: 1,
					duration: 1,
					ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
					onComplete: function () {
						thumbsTw.play();
					},
				});
			}
		});
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
